var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Loading, MessageBanner, TextArea, TextField, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { useOkapiKy } from "@folio/stripes/core";
import { AgendaChangeModal } from "./AgendaChangeModal";
import { AgendaHandlerChoice } from "./AgendaHandlerChoice";
import { ChangeAgendaDialog } from "./ChangeAgendaDialog";
import { leaveIssueLink, linkIssueToMonograph, setIssueAgenda, unlinkIssueFromMonograph, } from "../../api/agendaService";
import { useIssueAgenda } from "../../hooks/useAgenda";
import { otherAgenda, } from "../../types/agenda";
import { ROUTE_PATHS } from "../../types/routePaths";
import { ErrorType } from "../../types/ErrorType";
import { formatDateTime } from "../../utils/formatUtils";
import { formatIsbn, isCompleteIsbn } from "../../utils/isbn";
import { readErrorCode } from "../../utils/errorHandler";
import { isForbidden } from "../../utils/apiUtils";
import { ProvisionalTitleModal } from "../title/ProvisionalTitleModal";
import css from "./Agenda.module.css";
var monographDetailPath = function (titleId, isbn) {
    return "".concat(isbn ? ROUTE_PATHS.TITLES_WITH_ISBN : ROUTE_PATHS.TITLES_WITHOUT_ISBN, "?detail=").concat(titleId);
};
export var IssueAgendaSection = function (_a) {
    var _b, _c, _d;
    var issueId = _a.issueId, issueLabel = _a.issueLabel;
    var formatMessage = useIntl().formatMessage;
    var kyInstance = useOkapiKy();
    var agendaQuery = useIssueAgenda(issueId);
    var issueAgenda = agendaQuery.data;
    var link = (_b = issueAgenda === null || issueAgenda === void 0 ? void 0 : issueAgenda.specialIssueLink) !== null && _b !== void 0 ? _b : null;
    var _e = useState(null), action = _e[0], setAction = _e[1];
    var _f = useState(false), ownAgendaOpen = _f[0], setOwnAgendaOpen = _f[1];
    var _g = useState(""), isbn = _g[0], setIsbn = _g[1];
    var _h = useState(null), monographTitleId = _h[0], setMonographTitleId = _h[1];
    var _j = useState(null), handler = _j[0], setHandler = _j[1];
    var _k = useState(""), note = _k[0], setNote = _k[1];
    var _l = useState(null), unknownIsbn = _l[0], setUnknownIsbn = _l[1];
    var _m = useState(false), isbnTouched = _m[0], setIsbnTouched = _m[1];
    var _o = useState(null), provisionalMode = _o[0], setProvisionalMode = _o[1];
    useEffect(function () {
        if (action === null) {
            setIsbn("");
            setMonographTitleId(null);
            setHandler(null);
            setNote("");
            setUnknownIsbn(null);
            setIsbnTouched(false);
            setProvisionalMode(null);
        }
    }, [action]);
    var openAction = useCallback(function (next) { return function () {
        setAction(next);
        if (next === "changeHandler" && issueAgenda) {
            setHandler(otherAgenda(issueAgenda.agenda));
        }
    }; }, [issueAgenda]);
    var closeAction = useCallback(function () { return setAction(null); }, []);
    var openOwnAgenda = useCallback(function () { return setOwnAgendaOpen(true); }, []);
    var closeOwnAgenda = useCallback(function () { return setOwnAgendaOpen(false); }, []);
    var canChangeOwnAgenda = !!issueAgenda && (issueAgenda.canDecideOnItsOwn || issueAgenda.overridden);
    var handleChanged = useCallback(function () { return setAction(null); }, []);
    var trimmedIsbn = isbn.trim();
    var noteValue = note.trim() || undefined;
    var needsHandler = action === "link" || action === "join" || action === "changeHandler";
    var canSubmit = action !== null &&
        (!needsHandler || handler !== null) &&
        (action !== "link" || !!monographTitleId || isCompleteIsbn(trimmedIsbn));
    var run = useCallback(function (dryRun) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (action === "leave") {
                        return [2 /*return*/, leaveIssueLink(kyInstance, issueId, noteValue, dryRun)];
                    }
                    if (action === "unlink") {
                        return [2 /*return*/, unlinkIssueFromMonograph(kyInstance, issueId, noteValue, dryRun)];
                    }
                    if (!handler) {
                        throw new Error("The issue handler must be chosen before the change");
                    }
                    if (!(action === "link")) return [3 /*break*/, 6];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 6]);
                    return [4 /*yield*/, linkIssueToMonograph(kyInstance, issueId, monographTitleId
                            ? { monographTitleId: monographTitleId, agenda: handler, note: noteValue }
                            : { isbn: trimmedIsbn, agenda: handler, note: noteValue }, dryRun)];
                case 2: return [2 /*return*/, _b.sent()];
                case 3:
                    error_1 = _b.sent();
                    _a = !monographTitleId;
                    if (!_a) return [3 /*break*/, 5];
                    return [4 /*yield*/, readErrorCode(error_1)];
                case 4:
                    _a = (_b.sent()) === ErrorType.MONOGRAPH_ISBN_UNKNOWN;
                    _b.label = 5;
                case 5:
                    if (_a) {
                        setUnknownIsbn(trimmedIsbn);
                    }
                    throw error_1;
                case 6: return [2 /*return*/, setIssueAgenda(kyInstance, issueId, { agenda: handler, note: noteValue }, dryRun)];
            }
        });
    }); }, [
        action,
        kyInstance,
        issueId,
        monographTitleId,
        handler,
        noteValue,
        trimmedIsbn,
    ]);
    var previewKey = useMemo(function () { return [
        "issue",
        issueId,
        action,
        handler,
        action === "link" ? (monographTitleId !== null && monographTitleId !== void 0 ? monographTitleId : trimmedIsbn) : null,
    ]; }, [issueId, action, handler, monographTitleId, trimmedIsbn]);
    var handleIsbnChange = useCallback(function (e) {
        setIsbn(e.target.value);
        setMonographTitleId(null);
        setUnknownIsbn(null);
    }, []);
    var handleIsbnBlur = useCallback(function () { return setIsbnTouched(true); }, []);
    var handleNoteChange = useCallback(function (e) { return setNote(e.target.value); }, []);
    var openProvisional = useCallback(function () { return setProvisionalMode("withIsbn"); }, []);
    var openProvisionalWithoutIsbn = useCallback(function () { return setProvisionalMode("withoutIsbn"); }, []);
    var closeProvisional = useCallback(function () { return setProvisionalMode(null); }, []);
    var handleProvisionalCreated = useCallback(function (_a) {
        var titleId = _a.titleId;
        if (titleId) {
            setMonographTitleId(titleId);
            setUnknownIsbn(null);
        }
    }, []);
    var provisionalInitialValues = useMemo(function () { return ({
        name: "",
        isbn: provisionalMode === "withoutIsbn" ? "" : (unknownIsbn !== null && unknownIsbn !== void 0 ? unknownIsbn : trimmedIsbn),
        note: "",
    }); }, [provisionalMode, unknownIsbn, trimmedIsbn]);
    var headingId = "ui-br-legaldeposits.agenda.issue.dialog.".concat(action === "changeHandler" ? "join" : (action !== null && action !== void 0 ? action : "link"), ".heading");
    var introId = "ui-br-legaldeposits.agenda.issue.dialog.".concat(action === "changeHandler" ? "join" : (action !== null && action !== void 0 ? action : "link"), ".intro");
    return (React.createElement("div", { className: css.section, "data-test-id": "issue-agenda-section" },
        React.createElement("p", { className: css.statusLine },
            React.createElement("strong", null,
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.heading" }),
                ": "),
            issueAgenda && !link && (React.createElement("span", { "data-test-id": "issue-agenda-own-state" },
                React.createElement(FormattedMessage, { id: issueAgenda.overridden && issueAgenda.agenda === "MONOGRAPHS"
                        ? "ui-br-legaldeposits.agenda.issue.state.ownMonographs"
                        : "ui-br-legaldeposits.agenda.issue.notLinked" }),
                !issueAgenda.canDecideOnItsOwn && (React.createElement(React.Fragment, null,
                    " ",
                    React.createElement("span", { className: css.hint },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.merged" })))))),
            issueAgenda && link && (React.createElement(React.Fragment, null,
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.linkedTo" }),
                " ",
                React.createElement(Link, { to: monographDetailPath(link.monographTitleId, link.monographIsbn) }, (_c = link.monographTitle) !== null && _c !== void 0 ? _c : link.monographTitleId),
                link.monographIsbn && " (".concat(formatIsbn(link.monographIsbn), ")"),
                " ",
                React.createElement("span", { className: css.hint },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.linkedBy", values: {
                            who: (_d = link.createdByName) !== null && _d !== void 0 ? _d : "–",
                            when: formatDateTime(link.createdAt),
                        } })),
                " ",
                React.createElement("span", { "data-test-id": "issue-agenda-state" }, issueAgenda.joinedLink ? (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.state.joined", values: { handler: issueAgenda.agenda } })) : (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.state.notJoined" })))))),
        agendaQuery.isLoading && React.createElement(Loading, null),
        agendaQuery.isError && (React.createElement(MessageBanner, { type: "error" },
            React.createElement(FormattedMessage, { id: isForbidden(agendaQuery.error)
                    ? "ui-br-legaldeposits.agenda.issue.forbidden"
                    : "ui-br-legaldeposits.agenda.issue.loadFailed" }))),
        issueAgenda &&
            !link &&
            (canChangeOwnAgenda || issueAgenda.canDecideOnItsOwn) && (React.createElement("div", { className: css.actions },
            canChangeOwnAgenda && (React.createElement(Button, { onClick: openOwnAgenda, marginBottom0: true, "data-test-id": "issue-agenda-own" },
                React.createElement(FormattedMessage, { id: issueAgenda.agenda === "MONOGRAPHS"
                        ? "ui-br-legaldeposits.agenda.action.issueToPeriodicals"
                        : "ui-br-legaldeposits.agenda.action.issueToMonographs" }))),
            issueAgenda.canDecideOnItsOwn && (React.createElement(Button, { onClick: openAction("link"), marginBottom0: true, "data-test-id": "issue-agenda-link" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.action.link" }))))),
        issueAgenda && link && (React.createElement("div", { className: css.actions },
            issueAgenda.joinedLink ? (React.createElement(React.Fragment, null,
                React.createElement(Button, { onClick: openAction("changeHandler"), marginBottom0: true },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.action.changeHandler" })),
                React.createElement(Button, { onClick: openAction("leave"), marginBottom0: true },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.action.leave" })))) : (React.createElement(Button, { onClick: openAction("join"), marginBottom0: true, "data-test-id": "issue-agenda-join" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.action.join" }))),
            React.createElement(Button, { onClick: openAction("unlink"), marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.action.unlink" })))),
        React.createElement(ChangeAgendaDialog, { open: ownAgendaOpen, mode: "issue", name: issueLabel, titleAgenda: null, issueAgenda: issueAgenda !== null && issueAgenda !== void 0 ? issueAgenda : null, onClose: closeOwnAgenda, onChanged: closeOwnAgenda }),
        React.createElement(AgendaChangeModal, { open: action !== null, heading: formatMessage({ id: headingId }, { issue: issueLabel }), previewKey: previewKey, canSubmit: canSubmit, run: run, onClose: closeAction, onChanged: handleChanged, impactScope: "linkedPair" },
            React.createElement("p", null,
                React.createElement(FormattedMessage, { id: introId })),
            action === "link" && !monographTitleId && (React.createElement(TextField, { label: formatMessage({
                    id: "ui-br-legaldeposits.agenda.issue.isbn.label",
                }), value: isbn, onChange: handleIsbnChange, onBlur: handleIsbnBlur, error: isbnTouched &&
                    trimmedIsbn.length > 0 &&
                    !isCompleteIsbn(trimmedIsbn)
                    ? formatMessage({
                        id: "ui-br-legaldeposits.agenda.issue.isbn.invalid",
                    })
                    : undefined, required: true, "data-test-id": "issue-agenda-isbn" })),
            action === "link" && !monographTitleId && !unknownIsbn && (React.createElement("div", { className: css.fieldActions },
                React.createElement(Button, { onClick: openProvisionalWithoutIsbn, marginBottom0: true, "data-test-id": "issue-agenda-provisional-without-isbn" },
                    React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.noIsbn.create" })))),
            action === "link" && unknownIsbn && (React.createElement(MessageBanner, { type: "warning" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.unknownIsbn.message", values: { isbn: unknownIsbn } }),
                React.createElement("div", { className: css.actions },
                    React.createElement(Button, { onClick: openProvisional, marginBottom0: true },
                        React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.unknownIsbn.create" }))))),
            action === "link" && monographTitleId && (React.createElement(MessageBanner, { type: "success" },
                React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.agenda.issue.unknownIsbn.created" }))),
            needsHandler && (React.createElement(AgendaHandlerChoice, { name: "issue-agenda-handler", value: handler, onChange: setHandler })),
            React.createElement(TextArea, { label: formatMessage({
                    id: "ui-br-legaldeposits.agenda.dialog.note.label",
                }), value: note, onChange: handleNoteChange })),
        provisionalMode && (React.createElement(ProvisionalTitleModal, { open: true, onClose: closeProvisional, onCreated: handleProvisionalCreated, titleType: "MONOGRAPH", initialValues: provisionalInitialValues, showNotifyAgency: provisionalMode === "withIsbn", disableIsbn: provisionalMode === "withoutIsbn" }))));
};
